module.exports = __webpack_public_path__ + "img/integracao_logo_safe2pay.b109a194.png";